





import Vue from 'vue';
import { Partner } from '@/modules/kartoteka/partner';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { types } from '../../store/types';
import { SMLUVNI_PARTNER_TYP } from '../../constants';
import { store } from '../../store/edit';

export default Vue.extend({
	name: 'ZakazkaSmluvniPartnerSelect',
	components: { PartnerSelect: Partner.components.Select },
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		isDisabled(): boolean {
			return this.SmluvpartnerPzn !== SMLUVNI_PARTNER_TYP.JINY_PRIJEMCE;
		},
		mutationsMappers(): Record<string, string> {
			return {
				mutationName: `${this.storeUri}/${types.mutations.ZAKAZKA_SMLUVNI_PARTNER_SELECT_MAPPER}`,
			};
		},
		actionsMapper(): Record<string, string> {
			return {
				actionName: `${this.storeUri}/${types.actions.SMLUVNI_PARTNER_CHANGE}`,
			};
		},
	},
});
